import React from "react";
import { Button } from "@/components/ui/button";
import colorGroups from "./__ColorGroups";
import ShowGroupColors from "./__ShowGroupColors";

const buttonColors = colorGroups.find(
  (group) => group.group === "Button Colors"
);

const FormSection: React.FC = () => (
  <div className="w-full flex flex-col px-4">
    <div className="container mx-auto max-w-3xl py-20">
      <div className="flex items-center justify-center">
        <img
          src="/images/logo-square.png"
          alt="RepMates logo"
          width="512"
          height="512"
          className="w-24 h-auto"
        />
      </div>

      <h1 className="text-5xl md:text-7xl font-extrabold text-tx-dark text-center leading-tight mb-10">
        Button Styles
      </h1>

      <div className="w-full grid grid-cols-2 md:grid-cols-3 gap-4">
        <Button variant="primary" size="lg">
          Button Primary →
        </Button>
        <Button variant="secondary" size="lg">
          Button Secondary →
        </Button>
        <Button variant="outline" size="lg">
          Button Outline →
        </Button>

        <Button variant="caution" size="lg">
          Button Caution →
        </Button>
        <Button variant="destructive" size="lg">
          Button Destructive →
        </Button>
        <Button variant="link" size="lg">
          Button Link →
        </Button>
      </div>
    </div>

    <div className="container mx-auto max-w-3xl pb-20">
      <div className="w-full bg-bg-base rounded-lg p-4 md:p-20">
        {buttonColors && <ShowGroupColors colorGroup={buttonColors} />}
      </div>
    </div>
  </div>
);

export default FormSection;
